import React, { Component } from 'react';
import './styles.scss';
import { Link, withRouter } from 'react-router-dom';
import { UAH } from '../../filters';

class ProductCard extends Component {
  parentRoute = this.props.location.pathname;

  render() {
    const { id, name, img } = this.props.product;

    return (
      <Link to={`${this.parentRoute}/${name}`}>
        <div className="named-card" style={{ backgroundImage: `url(${img})` }}>
          <div className="named-card_stats __foo" hidden={this.props.lean}>
            <span className="named-card_stats-item">{UAH(800)}</span>
            <span className="named-card_stats-item">250шт</span>
          </div>
          <div className="named-card_title" hidden={this.props.lean}>{name}</div>
        </div>
      </Link>
    );
  }
}

export default withRouter(ProductCard);
